import * as React from 'react';
import Chip from '@mui/material/Chip';
import { useTranslation } from "react-i18next";
import { IColouredChipProps } from '../constants/FinanceModels';
import { Tooltip } from '@mui/material';

function ColouredChip(props: IColouredChipProps) {
    const {t} = useTranslation('finance');

    const show = () => {
        if (props.tooltip) {
            return (
                <Tooltip title={props.tooltip}>
                    <Chip label={t(`chips.${props.name}`)} color={props.color} icon={props.icon}/>
                </Tooltip>
            )
        }

        return (<Chip label={t(`chips.${props.name}`)} color={props.color} icon={props.icon}/>)

    }

    return (
        show()
    )
}

export default ColouredChip;